// extracted by css-extract-rspack-plugin
export default {"input":"EditableFileName_input__vs8cD"};